<template>
  <div>
    <navigation-tabs>
      <router-link
        v-for="(v, i) in visibleMenuList"
        :key="i"
        :to="{ name: v.pathName }"
      >
        {{ $t(v.name) }}
      </router-link>
    </navigation-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NavigationTabs from '@/components/utils/NavigationTabs'

export default {
  name: 'profile-menu',
  props: ['active'],
  components: {
    NavigationTabs
  },
  data: () => ({
    menuList: [
      {
        name: 'profile.menu.account_information',
        pathName: 'profile.info',
        hideTab: false
      },
      {
        name: 'profile.menu.subscription_and_billing',
        pathName: 'profile.subscription',
        hideTab: false
      }
      // {
      //   name: 'profile.menu.team_members',
      //   pathName: 'profile.team-members',
      //   active: 'TEAM MEMBERS',
      //   hideTab: false,
      //   icon: 'mdi-logout'
      // }
    ]
  }),
  computed: {
    ...mapGetters(['currentPlan', 'profile']),
    visibleMenuList () {
      return this.menuList.filter(item => !item.hideTab)
    }
  },
  async created () {
    await this.$store.dispatch('loadUserProfile')
    this.hideTab()
    this.hideMenuItemFromMembers()
  },
  methods: {
    hideTab () {
      const index = this.menuList.findIndex(e => e.pathName === 'profile.subscription')
      if (index !== -1 && this.currentPlan?.id === 'elabel-freemium') {
        this.menuList[index].hideTab = true
      }
    },
    hideMenuItemFromMembers () {
      const itemIdx = this.menuList.findIndex((item) => item.pathName === 'profile.team-members')
      if (itemIdx !== -1) {
        if (this.profile && this.profile.role !== 'brand_account_admin') {
          this.menuList[itemIdx].hideTab = true
        }
      }
    }
  }
}
</script>

<style lang="sass" scoped>
@import "@/variables.sass"
.profile-nav-list
  list-style: none
  margin: 0
  padding: 0
  display: flex
  flex-direction: column
</style>
